import type { AoisNotification } from '@hooks/queries/notifications/useDownloadNotifications.models';
import {
  UserNotificationDTO,
  UserNotificationStatus,
} from '@hooks/queries/notifications/userNotifications.models';
import dayjs from 'dayjs';
import {
  NOTIFICATIONS_SERVICES,
  NOTIFICATIONS_TRIGGERS,
  NotificationCenter,
} from './NotificationCenter.models';

function getNotificationService(
  templateId: string
): NotificationCenter.NotificationService | undefined {
  return NOTIFICATIONS_SERVICES.find((service) => service === templateId.split('.')[0]);
}

function getNotificationTrigger(
  templateId: string
): NotificationCenter.NotificationTrigger | undefined {
  return NOTIFICATIONS_TRIGGERS.find((trigger) => trigger === templateId.split('.')[1]);
}

function getNotificationsStatus(
  notificationStatus: UserNotificationStatus
): NotificationCenter.NotificationStatus | undefined {
  if (notificationStatus === 'SENT') {
    return 'UNREAD';
  } else {
    return 'READ';
  }
}

function parseUserNotifications(userNotifications: UserNotificationDTO[]) {
  return userNotifications.reduce<NotificationCenter.Notification[]>((acc, current) => {
    if (current.user_notification.content.phrase_key) {
      const service = getNotificationService(current.user_notification.content.phrase_key);
      const trigger = getNotificationTrigger(current.user_notification.content.phrase_key);
      const status = getNotificationsStatus(current.status);

      if (service && trigger && status) {
        acc.push({
          trigger,
          service,
          status,
          date: dayjs(current.created_at + 'Z').valueOf(),
          id: current.id,
        });
      }
    }

    return acc;
  }, []);
}

function parseDownloadNotifications(downloadNotifications: AoisNotification[]) {
  return downloadNotifications.reduce<NotificationCenter.Notification[]>((acc, cur) => {
    const isDroneUpload = cur.type === 'DRONE_UPLOAD';
    const service: NotificationCenter.NotificationService = isDroneUpload
      ? 'drone_upload'
      : 'image_download';
    const trigger: NotificationCenter.NotificationTrigger = isDroneUpload
      ? 'drone_image_upload'
      : 'image_catalog_file';
    const status = cur.metadata.read ? 'READ' : 'UNREAD';

    acc.push({
      service,
      trigger,
      status,
      date: dayjs(cur.created_at.replace(' ', 'T') + 'Z').valueOf(),
      id: cur.id,
    });

    return acc;
  }, []);
}

export { parseDownloadNotifications, parseUserNotifications };
